export const HOME_ASK_INTRO_PROMPT = 'Ask Henry anything about his life, work, or travels...';

const ASK_SAMPLE_PROMPT_LIST = [
  'What places have shaped Henry?',
  'What does Henry enjoy outside work?',
  'What is Henry currently exploring?',
  'What is Henry\'s research about?',
  'How does Henry connect cognitive science and AI?',
  'What projects has Henry built?',
  'What did Henry do at PwC and HSBC?',
  'What is Henry\'s work on mechanistic interpretability?',
  'What was Henry\'s time at Melbourne like?',
  'Where has Henry travelled?',
  'What is Henry\'s work on cognitive modelling?',
  'What did Henry do in 2025?',
  'How does Henry approach research and learning?',
  'Where has Henry studied and worked?',
  'How does Henry approach problem-solving?'
];

function shuffledPrompts(prompts) {
  const out = [...prompts];
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

export const ASK_SAMPLE_PROMPTS = shuffledPrompts(ASK_SAMPLE_PROMPT_LIST);
